export default class OhsWmmSysFieldFilterModels {
  sort: string;

  archived: boolean;

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor() {
    this.sort = '{ "key": "_id", "order": -1 }';
    this.archived = false;
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Created Order: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Created Order: Oldest to Newest', value: '{ "key": "_id", "order": 1 }' },
      ],
    };
  }
}
